import designAndCoding from './designAndCoding';
import tutorial from './tutorial/';
import user from './user';

export enum SessionMode {
  RUN,
  EDIT
}

export default {
  namespaced: true,
  modules: { designAndCoding, tutorial, user },
  state: {
    mode: SessionMode.EDIT,
    waitForFetching: true
  },
  getters: {
    isRunningMode(state) {
      return state.mode === SessionMode.RUN;
    },
    isEditingMode(state) {
      return state.mode === SessionMode.EDIT;
    }
  },
  mutations: {
    setRunMode(state) {
      state.mode = SessionMode.RUN;
    },
    setEditMode(state) {
      state.mode = SessionMode.EDIT;
    },
    setWaitForFetching(state, value) {
      state.waitForFetching = value;
    }
  },
  actions: {
    switchMode({ commit, getters }) {
      if (getters.isRunningMode) commit('setEditMode');
      else if (getters.isEditingMode) commit('setRunMode');
    }
  }
};
